import Vue from 'vue'
import { VueAuthenticate } from 'vue-authenticate';


const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
    tokenPath: 'token',
    tokenHeader: 'X-Ava-Authorization',
});

export default vueAuth;